// const getters = {
//   sidebar: state => state.app.sidebar,
//   device: state => state.app.device,
//   token: state => state.user.token,
//   avatar: state => state.user.avatar,
//   name: state => state.user.name,
//   roles: state => state.user.roles,
//   addRouters: state => state.permission.addRouters,
//   routers: state => state.permission.routers,
//   permissions: state => state.user.permissions,
//   permission_routes: state => state.permission.routes
// }
// export default getters
const getters = {
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    userId: state => state.user.userId,
    roles: state => state.user.roles,
    addRouters: state => state.permission.addRouters,
    routers: state => state.permission.routers,
    size: state => state.app.size,
    dict: state => state.dict.dict,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    introduction: state => state.user.introduction,
    permissions: state => state.user.permissions,
    permission_routes: state => state.permission.routes,
    topbarRouters:state => state.permission.topbarRouters,
    defaultRoutes:state => state.permission.defaultRoutes,
    sidebarRouters:state => state.permission.sidebarRouters,
  }
  export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js